import * as reactRedux from 'react-redux';
import type {UnknownAction} from 'redux';
import type {ThunkDispatch} from 'redux-thunk';
import type {RootState} from './modules';

export const useSelector = <Selected>(selector: (state: RootState) => Selected): Selected =>
  reactRedux.useSelector(selector);

export const useDispatch = (): ThunkDispatch<RootState, undefined, UnknownAction> =>
  reactRedux.useDispatch<ThunkDispatch<RootState, undefined, UnknownAction>>();
